import { forwardRef } from 'react';
export const MutualConnectionIcon = forwardRef(({ ...props }, ref) => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7338_69487)">
        <path
          d="M2.37041 6.21845C2.37041 5.56486 1.83876 5.0332 1.18516 5.0332H0.322266C0.144268 5.0332 0 5.17747 0 5.35547V7.08144C0 7.25935 0.144268 7.4037 0.322266 7.4037H1.18525C1.83876 7.4037 2.37041 6.87196 2.37041 6.21845ZM10.6777 5.0332H9.81475C9.16124 5.0332 8.6295 5.56494 8.6295 6.21845C8.6295 6.87196 9.16124 7.4037 9.81475 7.4037H10.6777C10.8557 7.4037 11 7.25935 11 7.08144V5.35555C11 5.17756 10.8557 5.0332 10.6777 5.0332ZM7.91633 4.34285C8.97576 4.34285 9.83767 3.48089 9.83767 2.42143C9.83765 1.36189 8.97574 0.5 7.9163 0.5C6.85676 0.5 5.99479 1.36197 5.99479 2.42143C5.99479 3.48089 6.85676 4.34285 7.9163 4.34285H7.91633ZM5.35028 2.42143C5.35028 1.36195 4.48839 0.5 3.42893 0.5C2.3694 0.5 1.50752 1.36197 1.50752 2.42143C1.50752 3.48089 2.3694 4.34285 3.42895 4.34285C4.48839 4.34285 5.35028 3.48089 5.35028 2.42143Z"
          fill={props?.color ?? '#9F9F9F'}
        />
        <path
          d="M4.53374 7.08137C4.53374 5.95644 5.08569 4.95819 5.93291 4.34277H3.08423C2.69313 4.34277 2.32134 4.42493 1.98481 4.57266C2.59443 4.86981 3.01548 5.4958 3.01548 6.21838C3.01548 7.22729 2.19471 8.04816 1.1857 8.04816H0.345703V9.84277C0.345703 10.0208 0.489971 10.165 0.667969 10.165H1.72633V8.76142C1.72633 8.58351 1.87077 8.43916 2.0486 8.43916C2.22677 8.43916 2.37086 8.58351 2.37086 8.76142V10.165H4.58913C4.55242 10.0616 4.53369 9.95257 4.53374 9.84277V7.08137Z"
          fill={props?.color ?? '#9F9F9F'}
        />
        <path
          d="M7.98505 6.21838C7.98505 5.4958 8.40611 4.86981 9.01572 4.57263C8.67919 4.42493 8.30738 4.34277 7.91633 4.34277C6.40385 4.34277 5.17773 5.56889 5.17773 7.08137V9.84277C5.17773 10.0208 5.322 10.165 5.5 10.165H8.62967V8.76142C8.62967 8.58351 8.77377 8.43916 8.95194 8.43916C9.12976 8.43916 9.2742 8.58351 9.2742 8.76142V10.165H10.3326C10.5106 10.165 10.6548 10.0208 10.6548 9.84277V8.04816H9.81475C8.80584 8.04816 7.98505 7.22731 7.98505 6.21838Z"
          fill={props?.color ?? '#9F9F9F'}
        />
      </g>
    </svg>
  );
});
